module.exports = __webpack_public_path__ + "static/img/third2_1_1.5de03cb2.jpg";